export default "__VITE_ASSET__BDTdsnhi__"